import { BigIntWithDecimals, PERCENT_DECIMALS } from "@silo/types";
import { convertCurrency, durationToSeconds, shiftDecimal } from "@silo/utils";
import { flow } from "fp-ts/lib/function";

type CalculateRewardsApr = (params: {
  emissionPerSecond: bigint;
  rewardTokenPriceUsd: BigIntWithDecimals;
  rewardTokenDecimals: number;
  totalTokens: BigIntWithDecimals;
  tokenPriceUsd: BigIntWithDecimals;
}) => bigint;

export const calculateRewardsApr: CalculateRewardsApr = ({
  emissionPerSecond,
  rewardTokenDecimals,
  rewardTokenPriceUsd,
  totalTokens,
  tokenPriceUsd,
}) => {
  // 1. extrapolate emissionPerSecond to a year to figure out emission per year
  const emissionPerYear = emissionPerSecond * SECONDS_IN_YEAR;

  const emissionPerYearUsd = convertCurrency(
    { value: emissionPerYear, decimals: rewardTokenDecimals },
    rewardTokenPriceUsd
  );

  const totalTokensValueUsd = convertCurrency(totalTokens, tokenPriceUsd);

  if (totalTokensValueUsd.value === 0n) {
    return 0n;
  }

  const apr =
    shiftDecimal(emissionPerYearUsd.value, PERCENT_DECIMALS) /
    totalTokensValueUsd.value;

  return apr;
};

const durationToBigIntSeconds = flow(durationToSeconds, BigInt);
const SECONDS_IN_YEAR = durationToBigIntSeconds({ years: 1 });
